<p-toast></p-toast>
<p-confirmDialog [closable]="false"></p-confirmDialog>

<!-- <div *ngIf="settingData.header === 'Add Item'"> -->
    <div class="flex align-items-end justify-content-end  my-2" >
        <button pButton pRipple type="button" label="Add Item" class="p-button-raised" (click)="addItem()"></button>
    </div>
    <div *ngIf="isEdit">
        <p-dialog header="Edit Item" appendTo="body" [(visible)]="isDialogShow" [modal]="true" [responsive]="true" (onHide)="hideDialog()" 
            [style]="{width: '20vw'}" [breakpoints]="{'960px': '75vw'}" [draggable]="false" [resizable]="false">
            <form #masterLookupForm="ngForm"   >
              <div class="col-12 md:col-6">
                <div class="field grid">
              <!-- <label htmlFor="suplliesNeeded">Supplies Needed</label> -->
              <input pInputText  placeholder="Add Items" name="value" [(ngModel)]="masterLookup.value"  required=""/>
                </div>
              </div>       
              <br>
              <div style="float: right;">
                <!-- <button pButton pRipple type="button" label="Add" (click)="save()"  (click)="updateRowValues()"  style="align-items: flex-end;"></button></div> -->
             
                <div style="margin-top: 5px; text-align: right;" class="flex gap-3 field justify-content-end">
            <p-button icon="pi pi-times" (click)="onCloseDialog()" label="Cancel" id="cancel"
            styleClass="p-button-secondary p-button-raised"></p-button>
            <p-button *ngIf="submitButton" icon="pi pi-check" label="Save" id="save" styleClass="p-button-success p-button-raised"
                (onClick)="save();updateRowValues()" [disabled]="!masterLookupForm.valid"></p-button >
            <p-progressSpinner *ngIf="!submitButton" [style]="{width: '15' , height: '30px'}" styleClass="custom-spinner" strokeWidth="8" fill="var(--surface-ground)" animationDuration=".8s"></p-progressSpinner>
                </div>
            </div>
              
            </form>
        </p-dialog>
    </div>
    <div *ngIf="!isEdit">
        <p-dialog header="Add Item" appendTo="body" [(visible)]="isDialogShow" [modal]="true" [responsive]="true" (onHide)="hideDialog()"
            [style]="{width: '20vw'}" [breakpoints]="{'960px': '75vw'}" [draggable]="false" [resizable]="false" >
            <form #masterLookupForm="ngForm"   >
              <div class="col-12 md:col-6">
                <div class="field grid">
              <!-- <label htmlFor="suplliesNeeded">Supplies Needed</label> -->
              <input pInputText  placeholder="Add Items" name="value" [(ngModel)]="masterLookup.value"  required=""/>
                </div>
              </div>       
              <br>
              <div style="float: right;">
                <!-- <button pButton pRipple type="button" label="Add" (click)="save()"  (click)="updateRowValues()"  style="align-items: flex-end;"></button></div> -->
             
                <div style="margin-top: 5px; text-align: right;" class="flex gap-3 field justify-content-end">
            <p-button icon="pi pi-times" (click)="onCloseDialog()" label="Cancel" id="cancel"
            styleClass="p-button-secondary p-button-raised"></p-button>
            <p-button *ngIf="submitButton" icon="pi pi-check" label="Save" id="save" styleClass="p-button-success p-button-raised"
                (onClick)="save();updateRowValues()" [disabled]="!masterLookupForm.valid"></p-button >
            <p-progressSpinner *ngIf="!submitButton" [style]="{width: '15' , height: '30px'}" styleClass="custom-spinner" strokeWidth="8" fill="var(--surface-ground)" animationDuration=".8s"></p-progressSpinner>
                </div>
            </div>
              
            </form>
        </p-dialog>
    </div>

    <p-table [value]="suppliesNeededItemList" dataKey="id" editMode="row" [tableStyle]="{'min-width': '40rem'}">
        <ng-template pTemplate="header">
            <tr>
                <th>Supplies Item</th>
                
                <th class="flex align-items-center justify-content-center gap-2">Action</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-supply let-editing="editing" let-ri="rowIndex">
            <tr [pEditableRow]="supply">
                <td>
                    {{supply.value}}
                </td>
                
                <td>
                    <div class="flex align-items-center justify-content-center gap-2">
                        <button  pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil" (click)="onRowEditInit(supply)" class="p-button-rounded p-button-text"></button>
                        <!-- <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check" (click)="onRowEditSave(supply)" class="p-button-rounded p-button-text p-button-success mr-2"></button> -->
                        <!-- <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times" (click)="onRowEditCan(supply, ri)" class="p-button-rounded p-button-text p-button-danger"></button> -->
                        <button  pButton pRipple type="button" pCancelEditableRow icon="pi pi-trash" (click)="onRowEditCancel(supply, ri,$event)" class="p-button-rounded p-button-text p-button-danger"></button>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>


<!-- </div> -->


